export default {
  user: {
    token: window.$cookies.get("token") || ""
  }
};
